import React from 'react';
import cx from 'classnames';

import { Features } from './Features/Features';
import { useVehicleFeaturesSection } from './useVehicleFeaturesSection';

import styles from './VehicleFeaturesSection.module.scss';

export const VehicleFeaturesSection: React.FC = () => {
	const { equipment, highValueCarFeatures, manuallyAddedAdditionalFeatures } = useVehicleFeaturesSection();
	const hasManuallyAddedAdditionalFeaturesOnly = manuallyAddedAdditionalFeatures && !equipment;

	return (
		<Features
			className={cx(styles.features, { [styles.withContentAbove]: !hasManuallyAddedAdditionalFeaturesOnly })}
			equipment={equipment}
			highValueCarFeatures={highValueCarFeatures}
			manuallyAddedAdditionalFeatures={manuallyAddedAdditionalFeatures}
		/>
	);
};
